import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from '../services/base.service';
import { CrmService } from '../services/crm.service';


@Injectable()
export class ProfileGuard  {
  constructor(
    private router: Router,
    private baseService: BaseService,
    private crmService: CrmService,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    await this.baseService.getProfile().toPromise();
    await this.baseService.getCompanyInfo().toPromise();
    await this.baseService.getPermissions().toPromise();
    await this.baseService.getIsExpired().toPromise();
    await this.crmService.getConfig().toPromise();
    return true;
  }

}
